import { render } from "./quiz5.vue?vue&type=template&id=6dc5e4c6"
import script from "./quiz5.vue?vue&type=script&lang=js"
export * from "./quiz5.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__